import styled, { css } from 'styled-components';

import { button } from '@/styles/shared';

import type { ButtonProps } from './Button.types';
import { SIZE, VARIANT } from './Button.types';

export const Button = styled.button<Partial<ButtonProps>>`
  ${button};

  ${({ size }) =>
    size === SIZE.SMALL &&
    css`
      padding: 7px 23px;
    `};

  ${({ variant, theme }) =>
    variant === VARIANT.SECONDARY &&
    css`
      background: rgba(0, 0, 0, 0.04);
      color: ${theme.palette.dark};
      border: none;
      font-weight: 400;

      &:hover {
        box-shadow: 0px 4px 14px -4px rgba(33, 33, 33, 0.25);
      }
    `};
`;
